export const staff = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'staff' })) } return false } })() },

  NavSidebar: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      // ─── HEADER ───────────────────────────────────
      PageHeader: {
        flow: 'x', align: 'center space-between', marginBottom: 'Z',
        '@mobileL': { flow: 'y', gap: 'Z' },
        TitleWrap: {
          flow: 'y', gap: 'Y',
          PageTitle: { tag: 'h1', text: 'Staff', fontSize: 'C', fontWeight: '700', color: 'inkText', letterSpacing: '-0.02em' },
          PageSubtitle: { text: '12 team members', fontSize: 'Z', color: 'inkMuted' }
        },
        AddStaffBtn: {
          tag: 'button', text: '+ Add Member',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'A',
          background: 'inkText', color: 'inkMid', border: 'none', cursor: 'pointer',
          transition: 'opacity 150ms ease', ':hover': { opacity: '0.8' }
        }
      },

      // ─── STATS ROW ────────────────────────────────
      StatsRow: {
        flow: 'x', gap: 'A', flexWrap: 'wrap', marginBottom: 'Z',
        '@mobileL': { flow: 'y' },
        StatDoctors: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
          StatValue: { text: '4', fontSize: 'C', fontWeight: '700', color: 'teal', letterSpacing: '-0.02em' },
          StatLabel: { text: 'Doctors', fontSize: 'Y', color: 'inkMuted' }
        },
        StatHygienists: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
          StatValue: { text: '2', fontSize: 'C', fontWeight: '700', color: 'green', letterSpacing: '-0.02em' },
          StatLabel: { text: 'Hygienists', fontSize: 'Y', color: 'inkMuted' }
        },
        StatAssistants: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
          StatValue: { text: '3', fontSize: 'C', fontWeight: '700', color: 'amber', letterSpacing: '-0.02em' },
          StatLabel: { text: 'Assistants', fontSize: 'Y', color: 'inkMuted' }
        },
        StatAdmin: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
          StatValue: { text: '3', fontSize: 'C', fontWeight: '700', color: 'purple', letterSpacing: '-0.02em' },
          StatLabel: { text: 'Admin / Front Desk', fontSize: 'Y', color: 'inkMuted' }
        }
      },

      // ─── DOCTORS ──────────────────────────────────
      DoctorsSection: {
        flow: 'y', gap: 'Z',
        SectionHeader: {
          flow: 'x', align: 'center flex-start', gap: 'Y', marginBottom: 'Y',
          Dot: { width: 'Z', height: 'Z', round: 'Z', background: 'teal', flexShrink: '0' },
          Title: { text: 'Doctors', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          Count: { text: '4 members', fontSize: 'Y', color: 'inkMuted', marginLeft: 'Y' }
        },
        Cards: {
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'A',

          Dr1: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder',
            borderTop: '3px solid teal',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: {
                width: 'C', height: 'C', round: 'C', background: 'teal.15',
                align: 'center center', flow: 'x', flexShrink: '0',
                Initials: { text: 'AL', fontSize: 'A', fontWeight: '700', color: 'teal' }
              },
              Info: {
                flow: 'y', gap: 'X',
                Name: { text: 'Dr. Ana Lomidze', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                Role: { text: 'General Dentist', fontSize: 'Y', color: 'teal', fontWeight: '600' },
                Since: { text: 'Since 2019', fontSize: 'Y', color: 'inkMuted' }
              }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon–Fri, 09:00–18:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 101 101', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow3: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'activity', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '8 patients today', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'teal.15', color: 'teal', width: 'fit-content', marginTop: 'Y' }
          },

          Dr2: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder',
            borderTop: '3px solid teal',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: {
                width: 'C', height: 'C', round: 'C', background: 'teal.15',
                align: 'center center', flow: 'x', flexShrink: '0',
                Initials: { text: 'GB', fontSize: 'A', fontWeight: '700', color: 'teal' }
              },
              Info: {
                flow: 'y', gap: 'X',
                Name: { text: 'Dr. Giorgi Beridze', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                Role: { text: 'Implantologist', fontSize: 'Y', color: 'teal', fontWeight: '600' },
                Since: { text: 'Since 2017', fontSize: 'Y', color: 'inkMuted' }
              }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon–Sat, 09:00–17:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 202 202', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow3: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'activity', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '6 patients today', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'teal.15', color: 'teal', width: 'fit-content', marginTop: 'Y' }
          },

          Dr3: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder',
            borderTop: '3px solid teal',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: {
                width: 'C', height: 'C', round: 'C', background: 'teal.15',
                align: 'center center', flow: 'x', flexShrink: '0',
                Initials: { text: 'NK', fontSize: 'A', fontWeight: '700', color: 'teal' }
              },
              Info: {
                flow: 'y', gap: 'X',
                Name: { text: 'Dr. Nino Kvaratskhelia', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                Role: { text: 'Orthodontist', fontSize: 'Y', color: 'teal', fontWeight: '600' },
                Since: { text: 'Since 2020', fontSize: 'Y', color: 'inkMuted' }
              }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Tue–Sat, 10:00–19:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 303 303', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow3: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'activity', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '5 patients today', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'teal.15', color: 'teal', width: 'fit-content', marginTop: 'Y' }
          },

          Dr4: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder',
            borderTop: '3px solid teal',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: {
                width: 'C', height: 'C', round: 'C', background: 'inkSurface',
                align: 'center center', flow: 'x', flexShrink: '0',
                Initials: { text: 'DM', fontSize: 'A', fontWeight: '700', color: 'inkMuted' }
              },
              Info: {
                flow: 'y', gap: 'X',
                Name: { text: 'Dr. Davit Mchedlidze', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                Role: { text: 'Endodontist', fontSize: 'Y', color: 'teal', fontWeight: '600' },
                Since: { text: 'Since 2022', fontSize: 'Y', color: 'inkMuted' }
              }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon, Wed, Fri, 10:00–17:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 404 404', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow3: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'activity', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Day off', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Part-time', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'amber.15', color: 'amber', width: 'fit-content', marginTop: 'Y' }
          }
        }
      },

      // ─── HYGIENISTS ───────────────────────────────
      HygienistsSection: {
        flow: 'y', gap: 'Z',
        SectionHeader: {
          flow: 'x', align: 'center flex-start', gap: 'Y', marginBottom: 'Y',
          Dot: { width: 'Z', height: 'Z', round: 'Z', background: 'green', flexShrink: '0' },
          Title: { text: 'Hygienists', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          Count: { text: '2 members', fontSize: 'Y', color: 'inkMuted', marginLeft: 'Y' }
        },
        Cards: {
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'A',

          Hyg1: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', borderTop: '3px solid green',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: { width: 'C', height: 'C', round: 'C', background: 'green.15', align: 'center center', flow: 'x', flexShrink: '0', Initials: { text: 'NG', fontSize: 'A', fontWeight: '700', color: 'green' } },
              Info: { flow: 'y', gap: 'X', Name: { text: 'Nino Gabrichidze', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, Role: { text: 'Dental Hygienist', fontSize: 'Y', color: 'green', fontWeight: '600' }, Since: { text: 'Since 2021', fontSize: 'Y', color: 'inkMuted' } }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon–Fri, 09:00–17:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 505 505', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow3: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'activity', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '7 patients today', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green', width: 'fit-content', marginTop: 'Y' }
          },

          Hyg2: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', borderTop: '3px solid green',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: { width: 'C', height: 'C', round: 'C', background: 'green.15', align: 'center center', flow: 'x', flexShrink: '0', Initials: { text: 'LT', fontSize: 'A', fontWeight: '700', color: 'green' } },
              Info: { flow: 'y', gap: 'X', Name: { text: 'Lali Tsereteli', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, Role: { text: 'Dental Hygienist', fontSize: 'Y', color: 'green', fontWeight: '600' }, Since: { text: 'Since 2023', fontSize: 'Y', color: 'inkMuted' } }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Tue–Sat, 10:00–18:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 606 606', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow3: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'activity', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '4 patients today', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green', width: 'fit-content', marginTop: 'Y' }
          }
        }
      },

      // ─── ASSISTANTS ───────────────────────────────
      AssistantsSection: {
        flow: 'y', gap: 'Z',
        SectionHeader: {
          flow: 'x', align: 'center flex-start', gap: 'Y', marginBottom: 'Y',
          Dot: { width: 'Z', height: 'Z', round: 'Z', background: 'amber', flexShrink: '0' },
          Title: { text: 'Dental Assistants', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          Count: { text: '3 members', fontSize: 'Y', color: 'inkMuted', marginLeft: 'Y' }
        },
        Cards: {
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'A',

          Asst1: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', borderTop: '3px solid amber',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: { width: 'C', height: 'C', round: 'C', background: 'amber.15', align: 'center center', flow: 'x', flexShrink: '0', Initials: { text: 'MK', fontSize: 'A', fontWeight: '700', color: 'amber' } },
              Info: { flow: 'y', gap: 'X', Name: { text: 'Mariam Kapanadze', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, Role: { text: 'Dental Assistant', fontSize: 'Y', color: 'amber', fontWeight: '600' }, Since: { text: 'Since 2022', fontSize: 'Y', color: 'inkMuted' } }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon–Fri, 08:30–17:30', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'users', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Assists Dr. Lomidze', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'amber.15', color: 'amber', width: 'fit-content', marginTop: 'Y' }
          },

          Asst2: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', borderTop: '3px solid amber',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: { width: 'C', height: 'C', round: 'C', background: 'amber.15', align: 'center center', flow: 'x', flexShrink: '0', Initials: { text: 'TG', fontSize: 'A', fontWeight: '700', color: 'amber' } },
              Info: { flow: 'y', gap: 'X', Name: { text: 'Tamar Gelashvili', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, Role: { text: 'Dental Assistant', fontSize: 'Y', color: 'amber', fontWeight: '600' }, Since: { text: 'Since 2023', fontSize: 'Y', color: 'inkMuted' } }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Tue–Sat, 09:00–18:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'users', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Assists Dr. Beridze', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'amber.15', color: 'amber', width: 'fit-content', marginTop: 'Y' }
          },

          Asst3: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', borderTop: '3px solid amber',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: { width: 'C', height: 'C', round: 'C', background: 'inkSurface', align: 'center center', flow: 'x', flexShrink: '0', Initials: { text: 'GD', fontSize: 'A', fontWeight: '700', color: 'inkMuted' } },
              Info: { flow: 'y', gap: 'X', Name: { text: 'Giorgi Dolidze', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, Role: { text: 'Dental Assistant', fontSize: 'Y', color: 'amber', fontWeight: '600' }, Since: { text: 'Since 2024', fontSize: 'Y', color: 'inkMuted' } }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon–Fri, 10:00–19:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'users', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Assists Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Probation', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'blue.15', color: 'blue', width: 'fit-content', marginTop: 'Y' }
          }
        }
      },

      // ─── ADMIN / FRONT DESK ───────────────────────
      AdminSection: {
        flow: 'y', gap: 'Z',
        SectionHeader: {
          flow: 'x', align: 'center flex-start', gap: 'Y', marginBottom: 'Y',
          Dot: { width: 'Z', height: 'Z', round: 'Z', background: 'purple', flexShrink: '0' },
          Title: { text: 'Admin & Front Desk', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          Count: { text: '3 members', fontSize: 'Y', color: 'inkMuted', marginLeft: 'Y' }
        },
        Cards: {
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'A',

          Admin1: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', borderTop: '3px solid purple',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: { width: 'C', height: 'C', round: 'C', background: 'purple.15', align: 'center center', flow: 'x', flexShrink: '0', Initials: { text: 'KJ', fontSize: 'A', fontWeight: '700', color: 'purple' } },
              Info: { flow: 'y', gap: 'X', Name: { text: 'Keti Javakhishvili', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, Role: { text: 'Practice Manager', fontSize: 'Y', color: 'purple', fontWeight: '600' }, Since: { text: 'Since 2018', fontSize: 'Y', color: 'inkMuted' } }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon–Fri, 08:00–17:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 707 707', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'purple.15', color: 'purple', width: 'fit-content', marginTop: 'Y' }
          },

          Admin2: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', borderTop: '3px solid purple',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: { width: 'C', height: 'C', round: 'C', background: 'purple.15', align: 'center center', flow: 'x', flexShrink: '0', Initials: { text: 'SM', fontSize: 'A', fontWeight: '700', color: 'purple' } },
              Info: { flow: 'y', gap: 'X', Name: { text: 'Salome Meladze', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, Role: { text: 'Receptionist', fontSize: 'Y', color: 'purple', fontWeight: '600' }, Since: { text: 'Since 2022', fontSize: 'Y', color: 'inkMuted' } }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon–Sat, 09:00–18:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 808 808', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'purple.15', color: 'purple', width: 'fit-content', marginTop: 'Y' }
          },

          Admin3: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', borderTop: '3px solid purple',
            CardTop: {
              flow: 'x', gap: 'A', align: 'center flex-start',
              Avatar: { width: 'C', height: 'C', round: 'C', background: 'purple.15', align: 'center center', flow: 'x', flexShrink: '0', Initials: { text: 'IA', fontSize: 'A', fontWeight: '700', color: 'purple' } },
              Info: { flow: 'y', gap: 'X', Name: { text: 'Irakli Abuladze', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, Role: { text: 'Billing Coordinator', fontSize: 'Y', color: 'purple', fontWeight: '600' }, Since: { text: 'Since 2023', fontSize: 'Y', color: 'inkMuted' } }
            },
            Divider: { height: '1px', background: 'inkBorder', margin: 'Z 0' },
            CardInfo: {
              flow: 'y', gap: 'Y',
              DetailRow1: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'calendar', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: 'Mon–Fri, 09:00–18:00', fontSize: 'Y', color: 'inkMuted' } },
              DetailRow2: { flow: 'x', gap: 'Y', align: 'center flex-start', Icon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'inkMuted' }, Val: { text: '+995 555 909 909', fontSize: 'Y', color: 'inkMuted' } }
            },
            StatusBadge: { text: 'Active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'purple.15', color: 'purple', width: 'fit-content', marginTop: 'Y' }
          }
        }
      }
    },
    MobileTabBar: {}
  }
}
